(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["managed-service-offers"]) return;
  try {
    
$('.button-container a.product-form').on('click', function(e) {
  e.preventDefault();
  $(e.currentTarget).parent("form").submit();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-our-team"]) return;
  try {
    
$('.meet-our-team-container').slick({
  centerMode: true,
  centerPadding: '24px',
  dots: false,
  arrows: false,
  slidesToShow: 4,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        centerMode: true,
        centerPadding: '20px',
        dots: false,
        arrows: false,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        centerMode: true,
        centerPadding: '20px',
        dots: false,
        arrows: false,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '24px',
        dots: false,
        arrows: false,
        slidesToShow: 2
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-home-team"] && !Shopify.designMode) return;
  try {
    
  $('.team').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 9,
    infinite: true,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-watermark-removal"]) return;
  try {
    
function writeError(msg) {
  var error = document.querySelector('.error');
  error.innerHTML = msg;
}

function showStep(step) {
  document.querySelectorAll('.step').forEach(function(element) {
    element.classList.add('hide');
  });
  document.querySelector(step).classList.remove('hide');
}

function updateTimer(string) {
  document.querySelector('.video_timer').innerHTML = string;
}

function downloadProgress(url) {
  let video_download = document.querySelector('.video_download');
  let video_download_content = document.querySelector('.video_download .button-content');
  console.log(video_download_content);
  video_download.disabled = true;
  video_download_content.innerText = "Downloading...";
  const startTime = new Date().getTime();

  request = new XMLHttpRequest();

  request.responseType = "blob";
  request.open('GET', url, true);
  request.send();

  request.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
        video_download_content.innerText = "Download the video";
        video_download.disabled = false;
        const blobURL = window.URL.createObjectURL(this.response);
        const anchor = document.createElement('a');
        anchor.href = blobURL;
        anchor.download = 'video.mp4';
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobURL);
    }
  }

  request.onprogress = function(e) {
    const percent_complete = Math.floor((e.loaded / e.total) * 100);
    const duration = (new Date().getTime() - startTime) / 1000;
    const bps = e.loaded / duration;
    const kbps = Math.floor(bps / 1024);
    const time = (e.total - e.loaded) / bps;
    const seconds = Math.floor(time % 60);
    const minutes = Math.floor(time / 60);

    let update = `${percent_complete}% - ${minutes} min ${seconds} sec remaining`;
    updateTimer(update);
  }
}

(function() {
  var form = document.querySelector('.tiktok-watermark-removal form');
  var input = form.querySelector('input');
  var video_title = document.querySelector('.video_title');
  var video_image = document.querySelector('.video_image');
  var video_author = document.querySelector('.video_author');
  var video_avatar = document.querySelector('.video_avatar');
  var video_download = document.querySelector('.video_download');
  var video_download_content = document.querySelector('.video_download .button-content');
  var restartButtons = document.querySelectorAll('.restart');

  restartButtons.forEach(function(restart) {
    restart.addEventListener('click', function(e) {
      e.preventDefault();
      video_download.disabled = false;
      video_download_content.innerHTML = "Download the video";
      video_title.innerHTML = "";
      video_author.innerHTML = "";
      video_download.dataset.href = "";
      video_image.src = "";
      video_avatar.src = "";
      updateTimer('');
      showStep('.stepForm');
    });
  })

  video_download.addEventListener('click', function(e) {
    e.preventDefault();
    downloadProgress(video_download.dataset.href);
  });
  
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var error = document.querySelector('.error');
    error.innerHTML = '';
    showStep('.stepWaiting');

    let value = input.value;
    if (value == '') {
      // Display en error
      return;
    }

    let url = 'https://watermark-removal.onrender.com/tiktok?url=' + value;
    
    fetch(url, {
      mode: 'cors',
      headers: {
        'Access-Control-Allow-Origin':'*'
      }
    })
    .then(response => {
      if (response.ok) {
        if (response.status == 429) {
            // Display error about too many requests
            writeError("Oops, you tried too many times. Please wait a minute before retrying.");
            showStep('.stepError');
            return;
        } else {
            response.json()
            .then(data => {
                video_title.innerHTML = data.title;
                video_image.src = data.cover;
                video_avatar.src = data.avatar
                video_author.innerHTML = data.author
                video_download.dataset.href = data.URL;
                showStep('.stepResult');
                return;
            })
        }
      } else {
        writeError("Something went wrong. Please try again ❤️");
        showStep('.stepError');
        return;
      }
    })
    .catch(error => {
      writeError("Something went wrong. Please try again ❤️");
      showStep('.stepError');
      return;
    });

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-our-clients-say"] && !Shopify.designMode) return;
  try {
    
  $('.reviews-container').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    centerMode: true,
    centerPadding: '100px',
    adaptiveHeight: true,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          centerMode: true,
          centerPadding: '240px',
          autoplay: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          autoplay: false,
          slidesToShow: 1,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-our-creators-say"] && !Shopify.designMode) return;
  try {
    
$('.reviews-container').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  infinite: true,
  centerMode: true,
  centerPadding: '100px',
  adaptiveHeight: true,
  dots: true,
  arrows: false,
    responsive: [
    {
      breakpoint: 1450,
      settings: {
        centerMode: true,
        centerPadding: '240px',
        autoplay: false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        autoplay: false,
        slidesToShow: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();
})();
